import './config';
import {apiBaseUrl}               from './config';
import {getBaseHeader}            from './utils';
import SfpBaseService             from './sfp-base-service';
import LocalAuthority             from '../../model/local-authority';
import Result                     from '../../model/result';

const LOCAL_AUTHORITIES_FRAGMENT = 'localauthorities'
const INVESTMENT_FRAGMENT        = `investment`
const OPERATION_FRAGMENT         = `operation`
const RESULTS_FRAGMENT           = 'results'

export default class ResultsService extends SfpBaseService {

    /** 
	 * @param   {LocalAuthority}       localAuthority
	 * @param   {Result}               result
	 * @returns {Promise<Result>} 
	 */
	static createResult(localAuthority, result) {
		const data = {
			amount:                result.amount,
			operation:             result.operation,
			year:                  result.year
		}

		const body    = JSON.stringify({result: data});
		const headers = { ...getBaseHeader(), 'Content-Type': 'application/json' };
		const method  = 'POST';
		const url     = `${apiBaseUrl}/${LOCAL_AUTHORITIES_FRAGMENT}/${localAuthority.slug}/${RESULTS_FRAGMENT}`;

		return fetch(url, { body, headers, method }).then(response => {
            if(!response.ok) return response.json().then(error => {throw error})

            return Result.createFromJson(response.json());
        });
    }
    
    /**
	 * @param {LocalAuthority} localAuthority 
	 * @param {Result}         result
	 * @returns {Promise} 
	 */
	static deleteResult(localAuthority, result) {
		const headers = { ...getBaseHeader() };
		const method  = 'DELETE';
		const url     = `${ResultsService._getBaseUrl(localAuthority, result.operation)}/${result.year}`

		return fetch(url, { headers, method }).then(response => {
            if(!response.ok) return response.json().then(error => {throw error})

            switch(response.status){
                case 204: return true
                default: 
            }
        });
    }
    
    /** 
	 * @param   {LocalAuthority}       localAuthority
	 * @param   {Result}               result
	 * @returns {Promise<Result>} 
	 */
	static updateResult(localAuthority, result) {
		const data = { amount: result.amount }

		const body    = JSON.stringify({ result: data });
		const headers = { ...getBaseHeader(), 'Content-Type': 'application/json' };
		const method  = 'PUT';
		const url     = `${ResultsService._getBaseUrl(localAuthority, result.operation)}/${result.year}`

		return fetch(url, { body, headers, method }).then(response => {
            if(!response.ok) return response.json().then(error => {throw error})

            return Result.createFromJson(response.json());
        });
	}
	
	/**
	 * @param {LocalAuthority} localAuthority 
	 * @param {boolean}        operation 
	 */
	static _getBaseUrl(localAuthority, operation) {
		return `${apiBaseUrl}/${LOCAL_AUTHORITIES_FRAGMENT}/${localAuthority.slug}/${RESULTS_FRAGMENT}/${operation ? OPERATION_FRAGMENT : INVESTMENT_FRAGMENT}`
	}
}


// WEBPACK FOOTER //
// ./src/service/sfp/results-service.js